import React, { useState } from "react";
import styled from "styled-components";
import { Container, Section, Eyebrow } from "../components/ui/Container";
import { colors, fonts, media, radius } from "../theme";

const items = [
  {
    q: "Is Everpesa a regulated lender?",
    a: "Yes. Everpesa is a licensed money lender in Uganda, regulated under the Tier 4 framework by the Uganda Microfinance Regulatory Authority. We operate within all applicable consumer protection, AML and data protection rules.",
  },
  {
    q: "How is investor principal protected?",
    a: "Everpesa maintains a first loss reserve and runs a five layer verification check on every borrower. If a loan defaults, the reserve covers principal so investors are made whole. Returns shown on the platform are already net of fees.",
  },
  {
    q: "What returns can I expect as an investor?",
    a: "Typical returns range from 4 to 7.6% per cycle, depending on the loan's risk tier and tenor. The exact return for each loan is shown transparently before you commit, and varies with the borrower profile and term.",
  },
  {
    q: "Who borrows on Everpesa?",
    a: "Mostly small and growing businesses such as market traders, hardware sellers, salon owners, food vendors, carpenters and farmers, who often cannot qualify for a bank loan because they lack land titles or formal bank statements.",
  },
  {
    q: "What does a loan cost the borrower?",
    a: "All in costs are typically 8 to 11% per cycle, priced by risk tier. Rates are fully disclosed before disbursement and tend to fall as borrowers build a positive repayment history with us.",
  },
  {
    q: "How fast can a borrower get funded?",
    a: "Once an application passes verification, the loan is listed and most loans are fully funded within hours. Capital is then disbursed straight to the borrower's mobile money account.",
  },
  {
    q: "Can I invest in Everpesa as a company?",
    a: "Yes. We work with strategic and institutional investors interested in backing the business itself. Reach out to sales@everpesa.com and our team will share an updated investor pack.",
  },
];

export const FAQ = () => {
  const [open, setOpen] = useState(0);

  return (
    <Section>
      <Container>
        <Head>
          <Eyebrow>Frequently asked</Eyebrow>
          <h2>Everything you might be wondering.</h2>
        </Head>

        <List>
          {items.map((it, i) => {
            const isOpen = open === i;
            return (
              <Item key={i} $open={isOpen}>
                <Q onClick={() => setOpen(isOpen ? -1 : i)} aria-expanded={isOpen}>
                  <span>{it.q}</span>
                  <Chev $open={isOpen} aria-hidden>
                    <span /><span />
                  </Chev>
                </Q>
                <A $open={isOpen}>
                  <p>{it.a}</p>
                </A>
              </Item>
            );
          })}
        </List>
      </Container>
    </Section>
  );
};

const Head = styled.div`
  text-align: center;
  margin-bottom: 48px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  align-items: center;
  h2 { font-family: ${fonts.display}; }
`;

const List = styled.div`
  max-width: 840px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Item = styled.div`
  border: 1px solid ${(p) => (p.$open ? colors.brand : colors.line)};
  border-radius: ${radius.md};
  background: ${(p) => (p.$open ? colors.brandSoft : "white")};
  transition: all 220ms ease;
`;

const Q = styled.button`
  width: 100%;
  background: transparent;
  border: 0;
  padding: 22px 26px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  text-align: left;

  span {
    font-family: ${fonts.display};
    font-weight: 600;
    font-size: 17px;
    color: ${colors.ink};
    ${media.sm} { font-size: 15.5px; }
  }
`;

const Chev = styled.span`
  position: relative;
  width: 14px;
  height: 14px;
  flex: 0 0 14px;
  display: inline-block;

  span {
    position: absolute;
    background: ${colors.brand};
    border-radius: 2px;
    transition: transform 220ms ease;
  }
  span:nth-child(1) {
    top: 50%; left: 0; right: 0; height: 2px; transform: translateY(-50%);
  }
  span:nth-child(2) {
    left: 50%; top: 0; bottom: 0; width: 2px; transform: translateX(-50%) rotate(${(p) => (p.$open ? "90deg" : "0")});
    transition: transform 220ms ease, opacity 220ms ease;
    opacity: ${(p) => (p.$open ? 0 : 1)};
  }
`;

const A = styled.div`
  overflow: hidden;
  max-height: ${(p) => (p.$open ? "320px" : "0")};
  transition: max-height 320ms cubic-bezier(0.22,1,0.36,1);
  p {
    padding: 0 26px 22px;
    color: ${colors.inkMuted};
    font-size: 15.5px;
    line-height: 1.7;
  }
`;
